import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getLatestActiveProjectsOfUser = async (
  { activeEmployerInfo = {}, isLocalApiRequest = false } = {}
) => {
  // includeRecordIds asks the API for { projectIds, recordProjectIds } instead
  // of the bare array, so the record-derived subset ("records" source mode)
  // comes along in the same request.
  const apiPath = `user/projects/record-activity-project-ids-last-30-days?includeRecordIds=true`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
